import { Redirect, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import AmenitiesContainer from './AmenitiesContainer';
import AmenityFormContainer from './AmenityFormContainer';
import AmenityInfoContainer from './AmenityInfoContainer';
import AmenityReservationFormContainer from './AmenityReservationFormContainer';
import AmenityReservationsContainer from './AmenityReservationsContainer';

import Route from '../../routes/SentryRoute';
import SecondLineTabs from '../Tabs/SecondLineTabs';
import TabsComponentWithLinks from '../Tabs/TabsComponentWithLinks';

const AmenityRouter = () => {
  const { t } = useTransl();
  const { path, url } = useRouteMatch();
  const location = useLocation();
  const firstLineTabs = [
    {
      label: t('title.amenityReservations'),
      url: `${url}/reservations`,
    },
    {
      label: t('title.amenities'),
      url: `${url}/management`,
    },
  ];
  const secondLineTabs = [
    {
      label: t('title.listView'),
      url: `${url}/reservations/list`,
    },
    {
      label: t('title.calendarView'),
      url: `${url}/reservations/calendar`,
    },
  ];

  const showSecondLineTabs =
    location.pathname.includes('/reservations/list') ||
    location.pathname.includes('/reservations/calendar');

  return (
    <>
      <TabsComponentWithLinks
        tabData={firstLineTabs}
        currentUrl={location.pathname}
      />
      {showSecondLineTabs && (
        <SecondLineTabs
          tabData={secondLineTabs}
          currentUrl={location.pathname}
        />
      )}
      <Box mt="2rem" />
      <Switch>
        <Route
          path={`${path}/reservations/list`}
          component={AmenityReservationsContainer}
          exact
        />
        <Route
          path={`${path}/reservations/calendar`}
          component={AmenityReservationsContainer}
          exact
        />
        <Route
          path={`${path}/management`}
          component={AmenitiesContainer}
          exact
        />
        <Route
          path={`${path}/management/info/:id`}
          component={AmenityInfoContainer}
        />
        <Route
          path={`${path}/reservations/:id`}
          component={AmenityReservationFormContainer}
        />
        <Route
          path={`${path}/management/:id`}
          component={AmenityFormContainer}
        />
        <Route path={`${path}`}>
          <Redirect to={`${url}/reservations/list`} />
        </Route>
      </Switch>
    </>
  );
};

export default AmenityRouter;
